import { render, staticRenderFns } from "./edit_promotion.vue?vue&type=template&id=0136d50f&"
import script from "./edit_promotion.vue?vue&type=script&lang=js&"
export * from "./edit_promotion.vue?vue&type=script&lang=js&"
import style0 from "./edit_promotion.vue?vue&type=style&index=0&id=0136d50f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports